import React, { useState, useEffect } from 'react';
import Icon from '../../../components/AppIcon';
import Button from '../../../components/ui/Button';
import { Link } from 'react-router-dom';

const EmailNotificationBanner = () => {
  const [visible, setVisible] = useState(true);
  const [dismissed, setDismissed] = useState(false);

  useEffect(() => {
    // Check if user has dismissed the banner
    const isDismissed = localStorage.getItem('emailNotificationBannerDismissed');
    if (isDismissed === 'true') {
      setVisible(false);
      setDismissed(true);
    }
  }, []);

  const handleDismiss = () => {
    localStorage.setItem('emailNotificationBannerDismissed', 'true');
    setVisible(false);
    setDismissed(true);
  };

  if (!visible) return null;

  return (
    <div className="bg-gradient-to-r from-primary/10 to-accent/10 border border-primary/20 rounded-lg p-4 mb-6">
      <div className="flex items-start gap-3">
        <div className="bg-primary/20 rounded-full p-2">
          <Icon name="Mail" size={20} color="var(--color-primary)" />
        </div>
        <div className="flex-1">
          <h3 className="text-sm font-semibold text-foreground mb-1">
            🎉 New Feature: Automated Email Notifications
          </h3>
          <p className="text-xs text-muted-foreground mb-3">
            Stay ahead of compliance deadlines! Configure automated email alerts for compliance deadlines and violation reports to keep your team informed.
          </p>
          <div className="flex items-center gap-2">
            <Link to="/email-notification-settings">
              <Button variant="primary" size="sm" iconName="Settings">
                Configure Notifications
              </Button>
            </Link>
            <Button variant="ghost" size="sm" onClick={handleDismiss}>
              Dismiss
            </Button>
          </div>
        </div>
        <button
          onClick={handleDismiss}
          className="text-muted-foreground hover:text-foreground transition-colors"
        >
          <Icon name="X" size={16} />
        </button>
      </div>
    </div>
  );
};

export default EmailNotificationBanner;